import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import Heading from "./Heading";
import { MapContainer, TileLayer, FeatureGroup, useMap } from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFloppyDisk,
  faArrowLeftLong,
} from "@fortawesome/free-solid-svg-icons";
import "../sass/NewLocation.scss";
import Input from "./Input";
import { isMobile } from "react-device-detect";

const NewLocation = () => {
  const [lat, setLat] = useState(51.5);
  const [long, setLong] = useState(-0.09);
  const [searchLoc, setSearchLoc] = useState(0);

  const featureGroupRef = useRef(null);
  const mapRef = useRef();

  const updateInput = (data) => {
    setSearchLoc(data.target.value);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      const url = `https://nominatim.openstreetmap.org/?city=${searchLoc}&format=json&limit=1`;

      fetch(url)
        .then((res) => res.json())
        .then(
          (result) => {
            // console.log("result", result);
            if (result.length > 0) {
              setLat(result[0].lat);
              setLong(result[0].lon);
            } else {
              alert("Type a proper city name");
            }
          },
          (error) => {
            console.log("error", error);
          }
        );
    }
  };

  function UpdateMapLoc() {
    const map = useMap();
    if (lat || long) {
      map.flyTo([lat, long], 14, {
        duration: 1,
      });
    }

    return null;
  }

  return (
    <div className="NewLocationWrapper">
      <div className="Header">
        <div>
          {!isMobile && (
            <Link to="/" className="Brand">
              earth
              <br />
              <strong>sights</strong>
            </Link>
          )}

          <Heading type="H1">Mark a new location</Heading>
        </div>
        <Link to="/">
          <FontAwesomeIcon icon={faArrowLeftLong} size="lg" /> Go back
        </Link>
      </div>
      <div className="NewLocationContainer">
        <div className="LocOption">
          {/* <Input label="Search city" type="text" /> */}

          <Input
            label="Search Location"
            type="text"
            onChange={updateInput}
            onKeyPress={handleKeyPress}
          />

          {/* <button onClick={handleOnFlyTo}>test</button> */}
          <span className="locInfo">
            Latitude: {lat}, Longitude: {long}
          </span>

          <span className="saveLoc">
            <select>
              <option>Agri</option>
            </select>
            <Input label="Location Name" type="text" />
            <button className="btn btn-primary">
              <FontAwesomeIcon icon={faFloppyDisk} size="lg" /> Save
            </button>
          </span>
        </div>
        <MapContainer
          center={[lat, long]}
          zoom={13}
          scrollWheelZoom={true}
          ref={mapRef}
        >
          <TileLayer
            attribution=" "
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          <UpdateMapLoc />

          <FeatureGroup ref={featureGroupRef}>
            <EditControl
              position="topright"
              onDrawStart={() => {
                featureGroupRef.current.clearLayers();
                setLat(0);
                setLong(0);
              }}
              onCreated={(e) => {
                const { lat, lng } = e.layer.getBounds().getCenter();
                setLat(lat);
                setLong(lng);
                // console.log("options", e.layer.getBounds().getCenter());
              }}
              draw={{
                circlemarker: false,
                marker: false,
                polygon: true,
                polyline: false,
                rectangle: true,
                circle: { metric: true },
              }}
            />
          </FeatureGroup>
        </MapContainer>
      </div>
    </div>
  );
};

export default NewLocation;
